<template>
  <b-modal
    v-model="inputVal.modal"
    :title="title"
    header-class="approval-modal__header"
    centered
    hide-footer
    no-enforce-focus
  >
    <div class="container">
      <div class="d-flex">
        <div class="col-12">
            <b-button variant="outline-secondary"
                      :disabled="loading"
                      @click="inputVal.modal = false">
              取消
            </b-button>
            <b-button
              variant="success"
              v-stream:click="onNotificationStatusUpdate"
              :disabled="loading"
            >
              <span>刪除</span>
            </b-button>
        </div>
      </div>
    </div>
    <LoadingSpinner v-show="loading"></LoadingSpinner>
  </b-modal>
</template>

<script>
import { BButton, BModal } from 'bootstrap-vue';
import { Subject } from 'rxjs';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import vModelMixin from '../../mixins/v-model';

export default {
  mixins: [vModelMixin],
  props: {
    loading: {
      type: Boolean,
    },
    onNotificationStatusUpdate: {
      type: Subject,
    },
  },
  data: () => ({
    init: {
      quickbars_insert_toolbar: false,
      height: '250',
    },
  }),
  components: {
    BButton,
    BModal,
    LoadingSpinner,
  },
  computed: {
    title() {
      return '確定刪除此消息？';
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .modal {
    &-dialog {
      max-width: 600px;
    }

    &-header {
      padding: 24px;
      border: none;
    }

    &-title {
      margin: 0 auto;
      font-size: 18px;
      font-weight: 400;
      color: #3a4047;
    }

    &-header .close {
      margin-left: -52px;
      margin-top: -12px;
      font-size: 20px;
    }

    &-body {
      padding: 0 24px 24px 24px;
    }

    &-body .col-12 {
      padding: 0;
      text-align: right;
    }

    .btn {
      margin-top: 24px;
      margin-left: 12px;
      width: 115px;
      padding: 10px 16px;

      &-success {
        background-color: #36b674 !important;
        border-color: #36b674 !important;
      }

      &-outline-secondary {
        background-color: #f9f9fa !important;
        border: 1px solid #dde1e5 !important;

        &:hover {
          background-color: #636d77 !important;
          border: 1px solid #636d77 !important;
        }
      }
    }
  }
}
</style>
